<template lang="pug">
.c-todos-content
  //- Teleport button to parent nav actions
  teleport(to="#resource-actions-portal" v-if="mounted")
    el-button.c-todos-action-btn(type="primary" @click="dialog=true")
      fai(type="fal" icon="plus-circle").me-2
      span Add New

  //- Table Section
  section.c-todos-table-section
    el-table(
      :data="items.items"
      v-loading="loading"
      @row-click="$router.push(`todos/${$event.id}`);"
      style="width: 100%"
    ).clickable-rows
      el-table-column(width="15")
      el-table-column(label="Todo" prop="todo")
      el-table-column(label="Protip" prop="protip")
      el-table-column(width="46")
        template(#default)
          .el-table__expand-icon
            img(src="@/assets/icons/light/chevron-right-light.svg")
      el-table-column(width="15")

  DialogAddTodo(
    v-if="dialog"
    :loading="loading"
    v-model="dialog"
    @save-item="saveTodo($event)"
    @close-dialog="dialog = false"
  )
</template>

<script lang="ts">
import { defineComponent, ref, reactive, onMounted } from 'vue';
import DialogAddTodo from './DialogAddTodo.vue';
import shared from '../shared';

export default defineComponent({
  name: 'Todos',
  components: { DialogAddTodo },
  setup() {
    const {
      doFindTodos,
      doMutateTodo,
      loading,
      dialog,
    } = shared();
    const mounted = ref(false);
    const items = reactive({ items: [] });
    async function getItems() {
      try {
        loading.value = true;
        items.items = await doFindTodos();
      } catch (err) {
        console.log(err);
      } finally {
        loading.value = false;
      }
    }
    async function saveTodo(item: any) {
      await doMutateTodo(item);
      await getItems();
    }
    onMounted(async () => {
      await getItems();
      mounted.value = true;
    });
    return {
      mounted,
      items,
      loading,
      dialog,
      saveTodo,
    };
  },
});

</script>

<style lang="scss" scoped>
// Color Variables
$gray-100: #f3f4f6;
$gray-600: #4b5563;
$gray-900: #111827;
$color-purple-text: #4349dd;

.c-todos-content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 0;
}

// Action button styles
.c-todos-action-btn {
  height: 36px;
  font-size: 14px;
  border-radius: 8px;
  background-color: white !important;
  border: 1.5px solid $color-purple-text !important;
  color: $color-purple-text !important;

  &:hover,
  &:focus {
    background-color: rgba($color-purple-text, 0.08) !important;
    border-color: color.adjust($color-purple-text, $lightness: -8%) !important;
    color: color.adjust($color-purple-text, $lightness: -8%) !important;
  }

  :deep(span) {
    font-weight: 500;
  }

  :deep(.me-2) {
    margin-right: 0.5rem;
  }
}

// Table Section
.c-todos-table-section {
  background: white;
  border-radius: 16px;
  border: 1px solid #dfdfdf;
  box-shadow: none;
  overflow: hidden;

  :deep(.el-table) {
    border-radius: 16px;
  }

  :deep(.el-table__inner-wrapper) {
    border-radius: 16px;
  }

  :deep(.clickable-rows) {
    .el-table__row {
      cursor: pointer;
      transition: background-color 0.2s;

      &:hover {
        background-color: $gray-100;
      }
    }
  }
}

// Responsive Design
@media (max-width: 768px) {
  .c-todos-action-btn {
    width: 100%;
  }
}
</style>
